export default __webpack_public_path__ + "static/media/icon_bookmark.994ec797.svg";